export const NoDrawing = () => {
  return (
    <div className="flex flex-col flex-1 h-full mx-auto p-6 bg-gray-50 justify-center items-center rounded-lg shadow-md">
      <p>数量表もしくは図面が選択されてません。</p>
    </div>
  );
};
